/* eslint-disable react/no-array-index-key */
/* eslint-disable react/prop-types */
import React, { useEffect, useState } from 'react';
import { Divider, Modal } from 'antd';
import moment from 'moment';

function ConfirmationModal({ setIsOpen, onConfirm, formData, form }) {
  const [isLoading, setIsLoading] = useState(false);
  const [shouldDisableConfirmButton, setShouldDisableConfirmButton] = useState(false);

  const formatTime = (time) => (time ? moment(time).format('HH:mm') : 'Não Preenchido');
  const formatDate = (date) => (date ? moment(date).format('DD/MM/YYYY') : 'Não Preenchido');

  const fieldsToConfirm = [
    'startHour', // Horário de Início
    'responsiblePersonNameLogistic', // Nome Responsável
    'responsiblePersonPhoneLogistic', // Telefone Responsável
    'responsiblePersonEmailLogistic', // E-mail Responsável
    'nameResponsibleConfirmation', // Nome Responsável Confirmação
    'emailResponsibleConfirmation', // E-mail Responsável Confirmação
    'phoneResponsibleConfirmation', // Telefone Responsável Confirmação
  ];

  const fieldsToConfirmTransport = [
    'boardingHour', // Horário de Embarque
    'arrivalHour', // Previsão de Chegada
    'postalCodeLogistic', // CEP
    'streetLogistic', // Rua
    'numberLogistic', // Número
    'districtLogistic', // Bairro
    'cityLogistic', // Cidade
    'stateLogistic', // Estado
  ];

  const fieldList = {
    comercial: [
      {
        key: 'dealClient',
        label: 'Nome do Cliente',
        value: formData.dealClient || 'Não Preenchido',
        mandatory: fieldsToConfirm.includes('dealClient'),
      },
      {
        key: 'startDate',
        label: 'Data do Treinamento',
        value: formatDate(formData.startDate),
        mandatory: fieldsToConfirm.includes('startDate'),
      },
      {
        key: 'product',
        label: 'Produto + Complemento',
        value:
          formData.product && typeof formData.product === 'object'
            ? `${formData.product.name} ${formData.product.complement || ''}`.trim()
            : formData.product || 'Não Preenchido',
        mandatory: fieldsToConfirm.includes('product'),
      },
      {
        key: 'dealNotes',
        label: 'Observação Oficial do Negócio',
        value: formData.dealNotes || 'Não Preenchido',
        mandatory: fieldsToConfirm.includes('dealNotes'),
      },
      {
        key: 'commercialNotes',
        label: 'Observação Comercial',
        value: formData.commercialNotes || 'Não Preenchido',
        mandatory: fieldsToConfirm.includes('commercialNotes'),
      },
    ],
    logistica: [
      {
        key: 'startHour',
        label: 'Horário de Início',
        value: formatTime(formData.startHour),
        mandatory: fieldsToConfirm.includes('startHour'),
      },
      {
        key: 'responsiblePersonNameLogistic',
        label: 'Nome Responsável',
        value: formData.responsiblePersonNameLogistic || 'Não Preenchido',
        mandatory: fieldsToConfirm.includes('responsiblePersonNameLogistic'),
      },
      {
        key: 'responsiblePersonPhoneLogistic',
        label: 'Telefone Responsável',
        value: formData.responsiblePersonPhoneLogistic || 'Não Preenchido',
        mandatory: fieldsToConfirm.includes('responsiblePersonPhoneLogistic'),
      },
      {
        key: 'responsiblePersonEmailLogistic',
        label: 'E-mail Responsável',
        value: formData.responsiblePersonEmailLogistic || 'Não Preenchido',
        mandatory: fieldsToConfirm.includes('responsiblePersonEmailLogistic'),
      },
      {
        key: 'nameResponsibleConfirmation',
        label: 'Nome Responsável Confirmação',
        value: formData.nameResponsibleConfirmation || 'Não Preenchido',
        mandatory: fieldsToConfirm.includes('nameResponsibleConfirmation'),
      },
      {
        key: 'emailResponsibleConfirmation',
        label: 'E-mail Responsável Confirmação',
        value: formData.emailResponsibleConfirmation || 'Não Preenchido',
        mandatory: fieldsToConfirm.includes('emailResponsibleConfirmation'),
      },
      {
        key: 'phoneResponsibleConfirmation',
        label: 'Telefone Responsável Confirmação',
        value: formData.phoneResponsibleConfirmation || 'Não Preenchido',
        mandatory: fieldsToConfirm.includes('phoneResponsibleConfirmation'),
      },
    ],
    transporte: [
      {
        key: 'boardingHour',
        label: 'Horário de Embarque',
        value: formatTime(formData.boardingHour),
        mandatory: fieldsToConfirmTransport.includes('boardingHour'),
      },
      {
        key: 'arrivalHour',
        label: 'Previsão de Chegada',
        value: formatTime(formData.arrivalHour),
        mandatory: fieldsToConfirmTransport.includes('arrivalHour'),
      },
      {
        key: 'postalCodeLogistic',
        label: 'CEP',
        value: formData.postalCodeLogistic || 'Não Preenchido',
        mandatory: fieldsToConfirmTransport.includes('postalCodeLogistic'),
      },
      {
        key: 'streetLogistic',
        label: 'Rua',
        value: formData.streetLogistic || 'Não Preenchido',
        mandatory: fieldsToConfirmTransport.includes('streetLogistic'),
      },
      {
        key: 'numberLogistic',
        label: 'Número',
        value: formData.numberLogistic || 'Não Preenchido',
        mandatory: fieldsToConfirmTransport.includes('numberLogistic'),
      },
      {
        key: 'districtLogistic',
        label: 'Bairro',
        value: formData.districtLogistic || 'Não Preenchido',
        mandatory: fieldsToConfirmTransport.includes('districtLogistic'),
      },
      {
        key: 'cityLogistic',
        label: 'Cidade',
        value: formData.cityLogistic || 'Não Preenchido',
        mandatory: fieldsToConfirmTransport.includes('cityLogistic'),
      },
      {
        key: 'stateLogistic',
        label: 'Estado',
        value: formData.stateLogistic || 'Não Preenchido',
        mandatory: fieldsToConfirmTransport.includes('stateLogistic'),
      },
    ],
  };

  const areAllFieldsFilled = (fields, taskData) =>
    fields.every((fieldKey) => {
      const value = taskData[fieldKey];
      if (Array.isArray(value)) {
        return value.length > 0;
      }
      return value !== undefined && value !== null && value !== '';
    });

  const updateButtonStates = () => {
    const taskData = form.getFieldsValue();
    const isTransportIncluded = taskData.trainingTransportation === 'Incluso';

    // Combina os campos obrigatórios baseado se o transporte está incluso
    const fieldsToValidate = isTransportIncluded
      ? [...fieldsToConfirm, ...fieldsToConfirmTransport]
      : fieldsToConfirm;

    const allFieldsFilled = areAllFieldsFilled(fieldsToValidate, taskData);

    setShouldDisableConfirmButton(!allFieldsFilled);
  };

  useEffect(() => {
    updateButtonStates();
  }, []);

  return (
    <Modal
      open={true}
      title="Confirmação dos Dados do Treinamento"
      onOk={async () => {
        setIsLoading(true);
        await onConfirm();
        setIsLoading(false);
        setIsOpen(false);
      }}
      onCancel={() => setIsOpen(false)}
      okText="Confirmar"
      cancelText="Cancelar"
      okButtonProps={{
        style: {
          backgroundColor: '#5cb85c',
          color: 'white',
          border: 'none',
          opacity: shouldDisableConfirmButton ? 0.3 : 1,
        },
        disabled: shouldDisableConfirmButton,
      }}
      confirmLoading={isLoading}
      cancelButtonProps={{ disabled: isLoading }}
      closable={!isLoading}
      maskClosable={!isLoading}
    >
      <div style={{ fontSize: '14px', lineHeight: '1.5' }}>
        <div>
          <p>Por favor, confira todos os dados antes de Confirmar o Treinamento!</p>

          <p style={{ fontStyle: 'italic' }}>
            Os campos com o prefixo &quot;<span style={{ color: '#d9534f' }}>*</span>&quot; são
            obrigatórios para Confirmar o Treinamento
          </p>
        </div>

        <Divider className="configuration-divider" orientation="left">
          Comercial
        </Divider>
        {fieldList.comercial.map(({ label, value, mandatory }, index) => (
          <div key={`comercial-${index}`} style={{ marginBottom: '4px' }}>
            {mandatory ? <span style={{ color: '#d9534f' }}>* </span> : null}
            <strong>{label}:</strong>{' '}
            {value === 'Não Preenchido' ? <span style={{ color: '#d9534f' }}>{value}</span> : value}
          </div>
        ))}

        <Divider className="configuration-divider" orientation="left" style={{ marginTop: 40 }}>
          Logística
        </Divider>

        {fieldList.logistica.map(({ label, value, mandatory }, index) => (
          <div key={`logistica-${index}`} style={{ marginBottom: '4px' }}>
            {mandatory ? <span style={{ color: '#d9534f' }}>* </span> : null}
            <strong>{label}:</strong>{' '}
            {value === 'Não Preenchido' ? <span style={{ color: '#d9534f' }}>{value}</span> : value}
          </div>
        ))}

        {formData.trainingTransportation === 'Incluso' && (
          <>
            <Divider className="configuration-divider" orientation="left" style={{ marginTop: 40 }}>
              Transporte
            </Divider>

            {fieldList.transporte.map(({ label, value, mandatory }, index) => {
              // O asterisco para campos de transporte só aparece se o transporte estiver incluso e o campo for mandatório.
              const showAsterisk = mandatory && formData.trainingTransportation === 'Incluso';
              return (
                <div key={`transporte-${index}`} style={{ marginBottom: '4px' }}>
                  {showAsterisk ? <span style={{ color: '#d9534f' }}>* </span> : null}
                  <strong>{label}:</strong>{' '}
                  {value === 'Não Preenchido' && showAsterisk ? (
                    <span style={{ color: '#d9534f' }}>{value}</span>
                  ) : (
                    value
                  )}
                </div>
              );
            })}
          </>
        )}
      </div>
    </Modal>
  );
}

export default ConfirmationModal;
